export default "__VITE_ASSET__Bp7OD0jw__"